<div *ngIf="order" class="d-flex align-items-center">
  <button class="btn icon dark" [disabled]="!order?.notes?.length" (click)="vieOrderNotes()">
    <mat-icon matTooltip="View Notes">notes</mat-icon>
  </button>
  <button class="btn icon dark" (click)="addOrderNotes()">
    <mat-icon matTooltip="Add Note">edit_note</mat-icon>
  </button>
</div>

<ng-template #notesDetail>
  <h2 class="order-log-title">Notes</h2>
  <div *ngIf="order?.notes?.length" class="invoice-log-sheet">
    <div class="order-log-row" *ngFor="let log of order.notes">
      <span class="log-row">
        {{ log.date | date: 'M/d/yy' }}
        <ng-container *ngIf="log.initials">&nbsp;|&nbsp;{{ log.initials }}</ng-container>
        <ng-container *ngIf="log.notes">&nbsp;|&nbsp;{{ log.notes }}</ng-container>
      </span>
    </div>
  </div>
</ng-template>

<ng-template #notesForm>
  <div *ngIf="noteForm" class="notes-form" [formGroup]="noteForm">
    <div class="container note-text">
      <mat-form-field class="w-100" floatLabel="never">
        <textarea
          matInput
          class="invoice-notes"
          formControlName="notes"
          rows="3"
          placeholder="Add Note"
        ></textarea>
      </mat-form-field>
    </div>

    <div class="fix-actions color">
      <div
        class="flex-grow-1 d-flex align-items-center justify-content-between no-shrink"
      >
        <div class="input signature">
          <mat-form-field floatLabel="never">
            <input
              class="sm signature"
              matInput
              required
              placeholder=""
              type="text"
              formControlName="initials"
            />
            <span matSuffix><mat-icon>gesture</mat-icon></span>
          </mat-form-field>
        </div>
        <div class="flex-grow-1 d-flex align-items-center justify-right">
          <button
            class="btn inverse"
            [disabled]="noteForm.invalid"
            (click)="addNote()"
          >
            <mat-icon class="lightest"> save </mat-icon>
          </button>
          <button mat-dialog-close class="btn icon secondary">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
